import type SymbolStyleTypeUtil from "./SymbolStyleTypeUtil";

const es = global.es; // TODO: Remove dependency!

export default class LineStyleTypeUtil {
    private symbolStyleTypeUtil: SymbolStyleTypeUtil;

    constructor(symbolStyleTypeUtil: SymbolStyleTypeUtil) {
        this.symbolStyleTypeUtil = symbolStyleTypeUtil;
    }

    /**
     * 
     * @param style 
     * @param geom 
     * @param point 
     * @param resolution 
     * 
     * @returns 
     */
    containsPoint(style, geom, point, resolution): boolean {
        let ret = false;

        let threshold = style.line.width;
        threshold = threshold ? Math.pow(threshold, 2) : 1;
        
        es.api.geom.extractLines(geom, (array, startIndex, endIndex) => { //Do distance from each line segment to point test
            if (!ret) {
                let ax = array[startIndex++];
                let ay = array[startIndex++];
                
                while (startIndex < endIndex) {
                    const bx = array[startIndex++];
                    const by = array[startIndex++];
                    
                    const distSq = es.util.math.pointLineDistSq(point[0], point[1], ax, ay, bx, by); // TODO: Shouldnt this be distance from line segment - not line?
                    if (distSq <= threshold) {
                        ret = true;
                        return;
                    }
                    
                    ax = bx;
                    ay = by;
                }
            }
        });
        
        return ret;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getColor(style) {
        return style.line.color;
    }
    
    /**
     * 
     * @param style 
     * @param color 
     * 
     * @returns 
     */
    withColor(style, color) {
        style = es.util.object.deepCopy(style);
        delete style._hash;
        
        style.line.color = color;
        return style;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    mainColor(style) {
        return this.getColor(style);
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getPaddingPx(style): number[] {
        let x,y;
        x = y = style.line ? style.line.width : 0;
        if (style.text) {
            x = Math.max(x, 256);
        }

        return [x, y];
    }

    /**
     * @deprecated just use style.text
     * @param style
     * @returns {*}
     */
    getText(style) {
        return style.text;
    }
    
    /**
     * 
     * @param style 
     * @param geom 
     * @param pnt 
     * 
     * @returns 
     */
    getFocalPoint(style, geom, pnt): any[] {
        return this.symbolStyleTypeUtil.getFocalPoint(style, geom, pnt);
    }
    
    /**
     * 
     * @param style 
     * @param geom 
     * 
     * @returns 
     */
    getFocalBounds(style, geom): any[] {
        return this.symbolStyleTypeUtil.getFocalBounds(style, geom);
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasDirect(style): boolean {
        return true;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasOverlays(style): boolean {
        return !!(style.text);
    }
}
